import Vue from 'vue'
import state from '@/lib/appState'
const BREAKPOINT = 768
const ACTIVE_CLASS = 'product-form-bar-active'
const SITE_HEADER_SELECTOR = '.js-header'

Vue.component('product-form-bar', {
  props: [],
  data () {
    const product = window.BARREL.product
    return {
      state,
      product,
      breakpoints: '(max-width: 767px)|(min-width: 768px)',
      headerHeight: 0,
      isMobile: true,
      lastScrollTop: 0
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandler)
    window.addEventListener('resize', this.resizeHandler)

    setTimeout(() => {
      this.resizeHandler()
      this.scrollHandler()
    }, 0)
  },
  methods: {
    docOffset() {
      const buttonSubmit = document.querySelector('.js-show-sticky-atc')

      if (buttonSubmit) {
        const rect = buttonSubmit?.getBoundingClientRect()
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop
        return rect.top + rect.height + scrollTop
      }

      return 0
    },
    scrollHandler() {
      const offsetTop = this.docOffset() - this.headerHeight
      const scrollTop = window.scrollY
      const footerEl = document.querySelector('#shopify-section-footer footer')
      const footerHeight = footerEl.offsetHeight
      const footerBottomPosition = footerEl.getBoundingClientRect().bottom
      const footerIsInViewPort = document.body.scrollHeight - scrollTop <= footerBottomPosition + footerHeight

      if (scrollTop >= offsetTop && scrollTop >= this.lastScrollTop && !footerIsInViewPort) {
        document.body.classList.add(ACTIVE_CLASS)
      } else {
        document.body.classList.remove(ACTIVE_CLASS)
      }
      this.lastScrollTop = scrollTop
    },
    resizeHandler() {
      const headerEl = document.querySelector(SITE_HEADER_SELECTOR)
      this.headerHeight = headerEl ? headerEl.offsetHeight : 0
      this.isMobile = window.innerWidth < BREAKPOINT
    },
  },
})